import React from 'react'

const AboutUs = () => {
    return (
        <section>
            <h4>The Story Behind Dream College Path</h4>
            <p>
            As a father, I experienced firsthand the overwhelming journey of college admissions. Watching my own child navigate SAT prep, AP coursework, and the complexity of applications, I quickly realized that the process was far more challenging than I had imagined. Between juggling school responsibilities, extracurricular activities, and college applications, it was clear that students—and parents—needed <b>structured guidance</b> to make informed decisions.
            One of the biggest challenges I faced was the <b>constant need for pickup and drop-off between different classes</b>—one for SAT prep, another for tutoring, and yet another for college counseling. The lack of a <b>centralized learning hub</b> made the entire process inefficient and exhausting. I knew there had to be a better way—one platform that could bring everything together.
            </p>
            <p>
            That realization led to the birth of <b>Dream College Path (DCP)</b> —a <b>one-stop solution</b> providing <b>high school students with expert guidance, test prep, tutoring, project-based learning, and college admissions counseling, all in one place</b>. DCP eliminates the hassle of <b>managing multiple services</b> by offering a <b>complete 360-degree view of student progress</b>—whether it’s <b>tutoring, SAT/ACT prep, or college essays</b>, parents and students can track their journey seamlessly.
            </p>
            <p>
            At DCP, we focus not just on getting students into top colleges, but on <b>helping them discover their strengths, build meaningful projects, and showcase their unique potential</b>.</p>
            <p>
            DCP wouldn’t have come to life without the dedication and expertise of my <b>Co-Founder, Pradyot Kar</b>, whose invaluable insights and strategic contributions played a crucial role in shaping our vision. His commitment to making <b>college admissions stress-free and efficient</b> has been instrumental in turning DCP into a reality.
            </p>
            <p>
            With Dream College Path, my goal is simple: <b>to create the resource I wish I had as a parent</b>—a support system that ensures every student can take charge of their future, stress-free. Because every dream deserves a path—and with the right guidance, every student can achieve their aspirations.
            </p>
            <p>
                <b>By</b>
                <div>
                    <b>Venkat Munjeti</b>
                </div>
                <div>
                    <b>Dad, DCP Founder & CEO</b>
                </div>
            </p>
            <p>
            </p>
            <p>
                
            </p>
        
        </section>
    )
}

export default AboutUs;